import _ from 'lodash'

const VALID_CREDIT_BLOCKS = [
  'directors',
  'director',
  'actor',
  'actors',
  'starring',
  'cast',
  'lyrics',
  'music director'
]

export default (creditBlocks) => {
  if (!creditBlocks)
    return []

  let filteredBlocks =
    _.filter(creditBlocks, (v, k) => {
      if (!v.title)
        return false

      v.title = v.title.trim().toLowerCase()
      return _.includes(VALID_CREDIT_BLOCKS, v.title)
    })

  return _.sortBy(filteredBlocks, 'title')
}
